/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import INIT from './modules/init'

// ページ読み込み
import HOME from './page/home'
import TECHNOLOGY from './page/technology';
import RECRUIT from './page/recruit';
import PROCESS from './page/process';
import GUIDANCE from './page/guidance';

/*****
 * サイト設定
 */
window.siteinfo = {
  viewport:         'width=1200',
}

/*****
 * サイト初期化
 */
INIT()

/*****
 * コンテンツごとのファイル読み込み
 */
// $.require({
//   disableCache:false,
//   '*':{
//     '/': ['/asset/css/home.min.css'],
//     '/technology': ['/asset/css/technology.min.css'],
//     '/guidance': ['/asset/css/guidance.min.css'],
//     '/recruit': ['/asset/css/recruit.min.css'],
//     '/process': ['/asset/css/process.min.css'],
//   },
// })
switch(location.pathname.replace('main.php','')){
  // トップページ
  case '/': HOME(); break
  case '/guidance/': GUIDANCE(); break
  case '/technology/': TECHNOLOGY(); break
  case '/recruit/': RECRUIT(); break
  case '/process/': PROCESS(); break
}
